'use strict';

import angular from 'angular';

import logModule from './log';
import locationsModule from './locations';
import contactsModule from './contacts';
import teamModule from './team';
import formsModule from './forms';
import manageModule from './manage';
import incidentModule from './incident';
import usersModule from './users';
import labelsModule from './labels';
import filesModule from './files';
import cityworksServiceRequestModule from './cityworks-service-requests';
import wichitaPumpStationsModule from './wichita-pump-stations';

import transferDirective from './transfer';
import escalationTransferDirective from './escalation-transfer';
import genericTransferDirective from './generic-transfer';

const MODULE_NAME = 'daupler.incidents.components.buttons';

var app = angular.module(MODULE_NAME, [
	'ui.bootstrap',
	'ui.router',
	logModule,
	locationsModule,
	contactsModule,
	teamModule,
	formsModule,
	manageModule,
	incidentModule,
	usersModule,
	labelsModule,
	filesModule,
	cityworksServiceRequestModule,
	wichitaPumpStationsModule,
]);

// This allows us to use ui-router's fancier resolve
app.config(function($uibResolveProvider) {
	'ngInject';
	$uibResolveProvider.setResolver('$resolve');
});
app.config(function(toastrConfig) {
	'ngInject';
	angular.extend(toastrConfig, {
		positionClass: 'toast-bottom-left',
		autoDismiss: true,
		maxOpened: 1,
	});
});
app.directive('incidentTransfer', transferDirective);
app.directive('incidentEscalationTransfer', escalationTransferDirective);
app.directive('incidentGenericTransfer', genericTransferDirective);

export default MODULE_NAME;
